import { defineStore, storeToRefs } from "pinia";
import { computed } from "vue";
import { useSurveyProfilesStore } from "../surveyProfiles";
import { useSurveyCardsStore } from "../surveyCards";
import { computedCardOptions, optionToCardToken, cardTokenToOption } from "@utils/computeCardOptions";
import { computedValuesOptions } from "@utils/computeConditionValuesOptions";
import { conditionCardToken } from "@utils/conditionData";

export const useProfileQuestionParamsStore = defineStore("profileQuestionParams", () => {
  // imported stores
  const surveyProfilesStore = useSurveyProfilesStore();
  const { selectedProfile } = storeToRefs(surveyProfilesStore);
  const surveyCardsStore = useSurveyCardsStore();
  const { cards } = storeToRefs(surveyCardsStore);
  const { findCardByToken } = surveyCardsStore;

  const currentQuestionParams = computed(() => selectedProfile.value?.question_params || []);
  const addQuestionParam = () => {
    selectedProfile.value.question_params.push({ answers: undefined, type: "is", card_token: undefined });
  };
  const removeQuestionParam = (index) => {
    selectedProfile.value.question_params.splice(index, 1);
  };

  const cardTokenModel = (token) => cardTokenToOption(token);
  const updateCardToken = (index, value) => {
    const param = selectedProfile.value.question_params[index];
    const cardToken = optionToCardToken(value);
    if (JSON.stringify(cardToken) === JSON.stringify(param.card_token)) return;

    param.card_token = cardToken;
    param.answers = [];
  };
  const cardTokenOptions = computed(() => {
    const validCards = cards.value.filter(
      (c) => c.type.startsWith("q_") && !["q_hidden", "q_city"].includes(c.type) && c.specs?.loop_token == undefined,
    );
    return computedCardOptions({ cards: validCards });
  });

  const typeOptions = computed(() => [
    { label: "is", value: "is" },
    { label: "is not", value: "is_not" },
  ]);

  const answerOptions = ({ card_token }) => {
    const card = findCardByToken({ token: conditionCardToken(card_token) });
    if (!card) return [];

    const sourceCard = card.type === "o_custom" ? findCardByToken({ token: card.specs?.question_reference }) : undefined;
    return computedValuesOptions(card, sourceCard);
  };

  return {
    currentQuestionParams,
    addQuestionParam,
    removeQuestionParam,

    cardTokenModel,
    updateCardToken,
    cardTokenOptions,

    typeOptions,
    answerOptions,
  };
});
